import SortBy from './SortBy.component';

export default SortBy;
